export default __webpack_public_path__ + "static/media/close.b89c9da3.svg";